import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {push} from 'react-router-redux';
import {bindActionCreators} from 'redux';

import * as DisplayMode from 'constants/DisplayMode';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SidebarWidget from '../betgames/SidebarWidget.jsx';

const messages = defineMessages({
    bookmarks: {
        id: 'menu.bookmarks',
        defaultMessage: 'Избранное'
    }
});

export default class Menu extends React.Component {
    static propTypes = {
        sports: React.PropTypes.object,
        sportsElement: React.PropTypes.func.isRequired,
        showSlider: React.PropTypes.bool.isRequired,
        showBookmarks: React.PropTypes.bool.isRequired,
        displayMode: React.PropTypes.object.isRequired,
        showAllSports: React.PropTypes.bool.isRequired,
        gridSelection: React.PropTypes.object.isRequired,
        showFavouritesCallback: React.PropTypes.func,
        selectionToggleCallback: React.PropTypes.func.isRequired,
        selectionToggleLeagueCallback: React.PropTypes.any
    };

    static contextTypes = {
        toggleMenu: React.PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {showMenu: false, filter: null, contentHeight: 0};
        this._onShowFavouritesClick = this._onShowFavouritesClick.bind(this);
        this._onSlideClick = this._onSlideClick.bind(this);

        this._handleWidthAdjust = this._handleWidthAdjust.bind(this);
    }

    componentDidMount() {
        if (this.refs.title === undefined) {
            return;
        }

        this._widthAdjustmentInterval = window.setInterval(this._handleWidthAdjust, 500);
    }

    componentWillUnmount() {
        if (this._widthAdjustmentInterval) {
            window.clearInterval(this._widthAdjustmentInterval);
        }
    }

    _handleWidthAdjust() {
        const contentWidth = this.refs.content.offsetWidth;
        const contentHeight = this.refs.content.offsetHeight;
        const titleWidth = this.refs.title.offsetWidth;

        if (contentHeight !== this.state.contentHeight) {
            this.setState({contentHeight});
            this.refs._scrollBarRef.updateScroll();
        }

        if (contentWidth !== titleWidth) {
            this.refs.title.style.width = contentWidth + 'px';
        }
    }

    _onShowFavouritesClick(e) {
        e.preventDefault();
        this.props.showFavouritesCallback();
    }

    _onSlideClick(e) {
        e.preventDefault();
        this.context.toggleMenu();
        this.refs._scrollBarRef.updateScroll();
    }

    static renderSports(sports, props) {
        const sportProps = {
            sports,
            push: bindActionCreators(push, props.dispatch),
            showBookmarks: props.showBookmarks,
            showCalendar: props.showCalendar,
            showMatches: props.showMatches,
            sportElement: props.sportElement,
            leagueElement: props.leagueElement,
            matchElement: props.matchElement,
            matchStatsElement: props.matchStatsElement,
            mainScoreElement: props.mainScoreElement,
            additionalScoresElement: props.additionalScoresElement,
            additionalScoreElement: props.additionalScoreElement,
            showAllSports: props.showAllSports,
            gridSelection: props.gridSelection,
            showAllCallback: props.showAllCallback,
            sportClickCallback: props.sportClickCallback,
            sportFavouriteClickCallback: props.sportFavouriteClickCallback,
            leagueClickCallback: props.leagueClickCallback,
            leagueFavouriteClickCallback: props.leagueFavouriteClickCallback,
            matchClickCallback: props.matchClickCallback,
            matchFavouriteClickCallback: props.matchFavouriteClickCallback,
            displayMode: props.displayMode,
            selectionToggleCallback: props.selectionToggleCallback,
            selectionToggleLeagueCallback: props.selectionToggleLeagueCallback
        };

        const SportsElement = props.sportsElement;

        return (<SportsElement {...sportProps} />);
    }

    render() {
        const sports = this.props.sports;
        const {showSlider, showBookmarks, displayMode, isShortcut, showWidget, countryCode} = this.props;

        const bookmarksCls = (displayMode.type == DisplayMode.FAVOURITE ? 'bookmarks selected' : 'bookmarks');

        return (
            <div id="menu-sports" className="sports-live">
                <div className="sports-list cf" id="menu-sports-list">
                    {showSlider && <div className="slide scroll--top" onClick={this._onSlideClick} ref="title">
                        <a href="#" className="slide-button"/>
                    </div>}
                    <div className="scroll--wrapper">
                        <PerfectScrollbar ref='_scrollBarRef'>
                            <div className="scroll--wrapper__inner" ref="content">
                                {showBookmarks && <div className={bookmarksCls}>
                                    <a href="#" className="sport-title" onClick={this._onShowFavouritesClick}>
                                        <FormattedMessage {...messages.bookmarks} />
                                    </a>
                                </div>}
                                {Menu.renderSports(sports, this.props)}
                            </div>
                            { (countryCode === 'KG' && !isShortcut) && <SidebarWidget /> }
                        </PerfectScrollbar>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/Menu.jsx